enum MessengerSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  STANDARD = 'standard',
  LARGE = 'large',
  XLARGE = 'xlarge',
}

export default MessengerSize;
